// CloudWatch RUM client init + helpers (see root FRONTEND_RUM_SETUP.md).
//
// PHI posture for a healthcare SPA:
//   - disableAutoPageView + sanitizePath(): routes embed patient ids; we record
//     the route shape, never the resolved id.
//   - recordResourceUrl:false — resource URLs can carry ids/tokens.
//   - allowCookies:false — anonymous per-event only, no consent surface.
// RUM must never break the app: every entry point is guarded and no-ops when
// the app monitor is not provisioned (local dev, un-wired envs).
import { AwsRum } from "aws-rum-web";
import { sanitizePath } from "./sanitizePath";
import environment from "../config/environment";
import { APP_VERSION } from "../config/env";

let awsRum = null;

export function initRum() {
  // Non-secret stack outputs, per environment, from src/config/environments.json.
  // null for "local" and for any environment with no app monitor provisioned.
  const { appMonitorId, identityPoolId, region, guestRoleArn } =
    environment.rum || {};

  // absent in local dev / any env not yet provisioned — silently no-op
  if (!appMonitorId || !identityPoolId || !region) return null;

  try {
    awsRum = new AwsRum(
      appMonitorId,
      APP_VERSION || "dev",
      region,
      {
        sessionSampleRate: 1,
        identityPoolId,
        guestRoleArn,
        endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
        telemetries: ["errors", "performance", "http"],
        allowCookies: false,
        enableXRay: false,
        disableAutoPageView: true, // we record sanitized route shapes instead
        recordResourceUrl: false, // resource URLs can carry ids/tokens
      }
    );
  } catch {
    awsRum = null; // RUM must never break app boot
  }
  return awsRum;
}

export function recordRumPageView(pathname) {
  if (!awsRum) return;
  try {
    awsRum.recordPageView(sanitizePath(pathname));
  } catch {
    /* telemetry must never throw */
  }
}

export function recordRumError(error) {
  if (!awsRum) return;
  try {
    awsRum.recordError(error);
  } catch {
    /* telemetry must never throw */
  }
}
